/*=====================================
    GameHomeSideBar

    Author: Ac
    CreateTime: 2018 / 10 / 01
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import CupoyImage from 'components/commons/CupoyImage';
import GLOBAL from 'nonnglobal';

/*--------------------------
    Styled
--------------------------*/
const Container = styled.div`
    min-width: ${GlobalStyle.SidebarWidth}px;
    width: ${GlobalStyle.SidebarWidth}px;
    margin-left: ${GlobalStyle.ViewSpace}px;
    padding-top: ${({ paddingTop }) => paddingTop ? '30px' : 0};
`;
const Block = GlobalStyle.BasicBlock.extend`
    width: 100%;
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;
const BlockTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    height: 54px;
    border-bottom: 1px solid #D9D9D9;
    font-size: 20px;
    color: #4A4A4A;
    font-weight: 600;
`;
const BlockMore = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #9B9B9B;
    cursor: pointer;
`;
const BlockMoreIcon = styled.div`
    margin-left: 10px;
    margin-top: -1px;
    font-size: ${({ size }) => size ? `${size}px` : '12px'};
`;
const ProductList = styled.ul`
    margin: 0;
`;
const Product = styled.li`
    margin: 20px 16px 16px;
    cursor: pointer;

    &:first-child {
        margin-top: 16px
    }
`;
const ProductInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #4A4A4A;
    font-size: 14px;
`;
const ProductImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 65%;
    margin-bottom: 8px;
`;
const ProductImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #E2DFDE;
`;
/*--------------------------
    Main Component
--------------------------*/
class GameHomeSideBar extends Component {

    // static propTypes = {
    // };

    constructor(props) {
        super(props);

        this.fetchListProfitEvents = this.fetchListProfitEvents.bind(this);

        this.state = {
        };
    }

    componentDidMount() {
        this.fetchListProfitEvents();
    }

    fetchListProfitEvents() {
        this.props.profitEventActions.listProfitEvents();
    }

    toProfitEvent = (eventid, clickurl) => {

        this.props.profitEventActions.logProfitEventClick({
            eventid,
        });
        window.location.assign(clickurl);
    }

    render() {

        const {
            profitEventIds,
            profitEventMap,
            paddingTop,
        } = this.props;

        if(profitEventIds.length === 0)
            return null;

        return (
            <Container paddingTop={paddingTop}>
                <Block>
                    <BlockTitle>
                        好康活動
                        <CupoySrefView
                            statename={CupoyRouter.STATES.PROFITEVENT}
                            stylecomponent={BlockMore}
                        >
                            更多
                            <BlockMoreIcon size={16}>
                                <i className="zmdi zmdi-caret-right-circle"></i>
                            </BlockMoreIcon>
                        </CupoySrefView>
                    </BlockTitle>
                    <ProductList>
                        {profitEventIds.map((eventId, index) => {

                            if(index >= 4) return null;

                            const profitEvent = profitEventMap[eventId];

                            const {
                                title = '',
                                eventimg,
                                clickurl,
                            } = profitEvent;

                            return (
                                <Product key={eventId} onClick={() => this.toProfitEvent(eventId, clickurl)}>
                                    <ProductImageWrapper>
                                        <CupoyImage
                                            src={GLOBAL.imgSrcRootURL + `/profiteventimgs/${eventId}/${eventimg}`}
                                            stylecomponent={ProductImage}
                                        />
                                    </ProductImageWrapper>
                                    <ProductInfo>
                                        {title.trim()}
                                    </ProductInfo>
                                </Product>
                            );
                        })}
                    </ProductList>
                </Block>
            </Container>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        profitEventMap: state.profitevent.itemMap,
        profitEventIds: state.profitevent.ids,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        profitEventActions: bindActionCreators(actionCreators.profitEventActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(GameHomeSideBar);